import RPMTab from '../RPM/RPMTab';

export default {
  superAdminRPM: {
    screen: RPMTab,
    expanded: true,
  },
};
